var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { cx } from 'emotion';
class Breadcrumbs extends PureComponent {
    render() {
        const _a = this.props, { children, className } = _a, rest = __rest(_a, ["children", "className"]);
        return (React.createElement("ul", Object.assign({ className: cx('breadcrumb', className) }, rest), children));
    }
}
Breadcrumbs.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
export default Breadcrumbs;
